<div class="descripted-toggle-section">
  <div class="input-text">
    <div class="input-text-title">{{ titleLabel | labelsProvider }}</div>
    <div class="input-text-description">
      {{ description | labelsProvider }}
    </div>
  </div>
  <div class="toggle-box-and-button">
    <div class="toggle-box" [ngClass]="{ 'toggle-box-disabled': !editable }">
      <app-on-off-toggle
        [isOn]="value"
        [editable]="editable"
        (toggleOnClick)="onClick($event)"
        [changeValueFromOutside$]="valueChangedFromOutside$"
      >
      </app-on-off-toggle>
    </div>
    <ng-content class="toggle-box-custom-element"></ng-content>
  </div>
</div>
